/**
 * Sprint 44.1 · Store de gestión de mesas del Portal Admin.
 *
 * Encapsula las llamadas al backend para:
 *  · Listar compras CONFIRMADAS de un evento (para cambiar mesa).
 *  · Consultar ocupación por mesa (capacidad, ocupados, disponibles).
 *  · Ejecutar el cambio de mesa (POST /compras/{id}/cambiar-mesa).
 *
 * Las validaciones de negocio (mesa DISPONIBLE, capacidad suficiente,
 * RBAC GERENCIA/SISTEMAS/EVENTOS, bitácora y notificación automática
 * al socio) están todas en el backend. Aquí sólo traducimos errores.
 */

import { api } from "@/services/api";

const ROLES_GESTION_MESAS = new Set(["GERENCIA", "SISTEMAS", "EVENTOS"]);

export const puedeGestionarMesas = (rol) =>
  !!rol && ROLES_GESTION_MESAS.has(String(rol).toUpperCase());

export const listarComprasConfirmadas = async (eventoId) => {
  try {
    const { data } = await api.get(
      `/compras/admin/evento/${encodeURIComponent(eventoId)}/confirmadas`
    );
    return data;
  } catch (err) {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    return { error: detail || (status === 403 ? "forbidden" : "network"), status };
  }
};

export const listarOcupacionMesas = async (eventoId) => {
  try {
    const { data } = await api.get(
      `/compras/admin/evento/${encodeURIComponent(eventoId)}/mesas-ocupacion`
    );
    return data;
  } catch (err) {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    return { error: detail || (status === 403 ? "forbidden" : "network"), status };
  }
};

/**
 * Cambia la mesa de una compra confirmada.
 * @param {string} compraId
 * @param {number} mesa mesa destino (número entero)
 * @param {string|undefined} motivo opcional, máx. 240 chars
 * @returns {Promise<{ok:true,cambio:boolean,...} | {error,status}>}
 */
export const cambiarMesaCompra = async (compraId, mesa, motivo) => {
  try {
    const payload = { mesa: Number(mesa) };
    const m = (motivo || "").trim();
    if (m) payload.motivo = m.slice(0, 240);
    const { data } = await api.post(
      `/compras/${encodeURIComponent(compraId)}/cambiar-mesa`,
      payload
    );
    return data;
  } catch (err) {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    return { error: detail || "network", status };
  }
};
